export enum CarrierLabelErrorDictionary {
  "UNKNOWN" = "UNKNOWN",
  "INVALID_HS_CODE" = "INVALID_HS_CODE",
  "INVALID_EORI_NUMBER" = "INVALID_EORI_NUMBER",
  // Popal service errors
  "SERVICE_UNAVAILABLE" = "SERVICE_UNAVAILABLE",
  "SERVICE_TIMEOUT" = "SERVICE_TIMEOUT",
  "CONNECTION_RESET" = "CONNECTION_RESET",
  "CONNECTION_ERROR" = "CONNECTION_ERROR",
  "DATABASE_TIMEOUT" = "DATABASE_TIMEOUT",
  // Popal validation errors
  "PHONE_REQUIRED" = "PHONE_REQUIRED",
  "PHONE_EMPTY" = "PHONE_EMPTY",
  "PHONE_INVALID" = "PHONE_INVALID",
  "SENDER_NAME_REQUIRED" = "SENDER_NAME_REQUIRED",
  "RECIPIENT_NAME_LENGTH" = "RECIPIENT_NAME_LENGTH",
  "RECIPIENT_NAME_TOO_LONG" = "RECIPIENT_NAME_TOO_LONG",
  "RECIPIENT_NAME_TOO_SHORT" = "RECIPIENT_NAME_TOO_SHORT",
  "SENDER_NAME_TOO_SHORT" = "SENDER_NAME_TOO_SHORT",
  "CITY_TOO_LONG" = "CITY_TOO_LONG",
  "INVALID_POSTCODE" = "INVALID_POSTCODE",
  "WEIGHT_REQUIRED" = "WEIGHT_REQUIRED",
  "WEIGHT_INVALID" = "WEIGHT_INVALID",
  "WEIGHT_MISMATCH" = "WEIGHT_MISMATCH",
  "WEIGHT_REQUIRED_NI" = "WEIGHT_REQUIRED_NI",
  "CURRENCY_MISMATCH" = "CURRENCY_MISMATCH",
  "COMMODITY_CODE_REQUIRED" = "COMMODITY_CODE_REQUIRED",
  "INVALID_ORDER_REFERENCE" = "INVALID_ORDER_REFERENCE",
  "PRODUCT_DESCRIPTION_REQUIRED" = "PRODUCT_DESCRIPTION_REQUIRED",
  "INVALID_PRODUCT_QUANTITY" = "INVALID_PRODUCT_QUANTITY",
  "SYSTEM_ERROR" = "SYSTEM_ERROR",
  "ORDER_NOT_FOUND" = "ORDER_NOT_FOUND",
  "SERVICE_PROVIDER_ERROR" = "SERVICE_PROVIDER_ERROR",
  "ROUTING_FAILED" = "ROUTING_FAILED",
  "FUNCTION_EXECUTION_FAILED" = "FUNCTION_EXECUTION_FAILED",
  "DATA_PROCESSING_ERROR" = "DATA_PROCESSING_ERROR",
  "ORDER_PLACEMENT_FAILED" = "ORDER_PLACEMENT_FAILED",
  "BILLING_CALCULATION_FAILED" = "BILLING_CALCULATION_FAILED",
  "UNKNOWN_ERROR" = "UNKNOWN_ERROR",
}


